module.exports = __webpack_public_path__ + "static/silvanus-DND3_FnP-46cc905e12374354ef58d0f6159e86e6.webp";